import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import flags from '../../../../icons/flags.png';
import './login.css';
import styles from '../../../Badging/authentication/components/login.module.scss';

const LoginForm = ({
  handleInputChange,
  handleSignIn,
  errors,
  handleInputBlurred,
  blurredFields,
  cognitoPhoneError,
  phone,
  errorMessage,
  invalid_phone
}) => (
  <form name="loginForm" className={`${styles.login_form} ${styles.login_form1}`} onSubmit={handleSignIn} noValidate>
    <div className={styles.login_form_wrapper}>
     <div className={styles.login_message}>
      <FormattedMessage id="authentication.login.badging"
      defaultMessage="Please enter your mobile number." />
     </div>
    <div className={styles.column_wrapper}>
      <div className={styles.form_column}>
        <label htmlFor="phone">
          <ReactTelInput
            type="text"
            id="phone"
            flagsImagePath={flags}
            onChange={(e) => { handleInputChange('phone', e); }}
            onBlur={() => { handleInputBlurred('phone'); }}
            name="phone number"
            required value={phone} classNames={styles.telephoneInput}
            defaultCountry="us" placeholder="Phone Number"
            inputProps={{ placeholder: 'Enter Phone Number' }}
          />
          <div className={styles.circle_green} />
        </label>
        {(errorMessage || invalid_phone) ? (
          <small className={styles.error}>
            <FormattedMessage id={errorMessage
              ? 'authentication.login.error.invalid_user'
              : 'pulpoforms.errors.invalid_phone_number'} defaultMessage={errorMessage ? 'Invalid User' : 'Invalid Phone Number'} />
          </small>
        ) : (
          <>
        {blurredFields?.phone && errors?.phoneEmpty ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.error.email_empty" defaultMessage="This field cannot be empty" />
          </small>
        ) : null}
        {blurredFields?.phone && cognitoPhoneError ? (
          <small className={styles.error}>
            <FormattedMessage id="authentication.login.cognito.phone_error"
            defaultMessage="The phone number you entered is not registered in the system.
             Please try again with another number or contact your system administrator." />
          </small>
        ) : null}
        {!blurredFields?.phone || (!errors?.phoneEmpty && !errors?.phoneInvalid) ? (
          <small className={styles.empty_error} />
        ) : null}
          </>
        )}
      </div>
    </div>
    {errors?.invalidCredentials ? (
      <div className={`${styles.error} ${styles.invalid_credentials}`}>
        <FormattedMessage id="authentication.login.error.invalid_credentials" defaultMessage="Invalid Credentials" />
      </div>) : null}
      <div className={styles.button_wrapper}>
      <button
        type="submit"
        className={styles.button}
      >
        <FormattedMessage id="authentication.login.get_code" defaultMessage="Get Code" />
      </button>
      </div>
    </div>
  </form>
);


LoginForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleSignIn: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  blurredFields: PropTypes.shape({
    emailValid: PropTypes.bool
  }).isRequired,
  handleInputBlurred: PropTypes.func.isRequired
};

export default LoginForm;
